<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div  class="animated fadeIn">
    <template v-if="base">
      <List v-show="list" ref="list" />
    </template>
    <Detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { Api } from '@/f1/service';

import List from './User.List';
import Detail from './User.Detail';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('[vue] user', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created: function() { console.log('[vue] user', 'created'); },
  destroyed: function() { console.log('[vue] user', 'destroyed'); },
  mounted: function() {
    console.log('[vue] user', 'mounted');
    this.select(this.$route.params);
  },
}
</script>
